// The table's sort order: which column, which direction, and the documents
// and folders sorted accordingly. Folders always sit above the files; they
// only carry a name, so they follow the name sort direction when that's the
// active key and stay A→Z otherwise.

import { useState } from 'react';
import type { IDocument, IFolder } from '@apis/documents';

export type SortKey = 'name' | 'sizeBytes' | 'updatedAt';
type SortDir = 'asc' | 'desc';

export function useTableSort(documents: IDocument[], folders: IFolder[]) {
  const [sortKey, setSortKey] = useState<SortKey>('updatedAt');
  const [sortDir, setSortDir] = useState<SortDir>('desc');

  function handleSort(key: SortKey) {
    if (sortKey === key) {
      setSortDir((d) => (d === 'asc' ? 'desc' : 'asc'));
    } else {
      setSortKey(key);
      setSortDir('desc');
    }
  }

  const sorted = [...documents].sort((a, b) => {
    let comparison = 0;
    if (sortKey === 'name') comparison = a.name.localeCompare(b.name);
    if (sortKey === 'sizeBytes') comparison = a.sizeBytes - b.sizeBytes;
    if (sortKey === 'updatedAt') comparison = a.updatedAt.localeCompare(b.updatedAt);
    return sortDir === 'asc' ? comparison : -comparison;
  });

  const sortedFolders = [...folders].sort((a, b) => {
    const comparison = a.name.localeCompare(b.name);
    return sortKey === 'name' && sortDir === 'desc' ? -comparison : comparison;
  });

  return { handleSort, sorted, sortedFolders };
}